/*
 * @Author: your name
 * @Date: 2021-09-06 21:08:56
 * @LastEditTime: 2021-11-03 21:54:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qklproject\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "Index" */ '../views/PC/Index.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '../views/PC/About.vue')
  },
  {
    path: '/skills',
    name: 'Skills',
    component: () => import(/* webpackChunkName: "Skills" */ '../views/PC/Skills/Skills.vue')
  },
  {
    path: '/hotTask',
    name: 'HotTask',
    component: () => import(/* webpackChunkName: "HotTask" */ '../views/PC/HotTask/HotTask.vue')
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import(/* webpackChunkName: "Projects" */ '../views/PC/HotTask/Projects.vue')
  },
  {
    path: '/allTask',
    name: 'AllTask',
    component: () => import(/* webpackChunkName: "AllTask" */ '../views/PC/AllTask/AllTask.vue')
  },
  {
    path: '/my',
    name: 'My',
    component: () => import(/* webpackChunkName: "My" */ '../views/PC/My/My.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
